import { WebReportEvent, JsErrorReport } from '@slardar/sdk-web';
import BasePlugin from './base-plugin';

const REG =
  /failed to fetch|Failed to fetch|Network Error|NetworkError|Loading chunk|timeout of|Request aborted/i;

export default class NetworkPlugin extends BasePlugin {
  handle(event: JsErrorReport) {
    const { payload } = event;
    const { error } = payload;
    if (error?.message?.includes('Loading chunk')) {
      // integrate Loading chunk error
      payload.extra = {
        ...payload.extra,
        content: error?.message || '',
        level: 'warn',
      };
    } else {
      payload.extra = {
        ...payload.extra,
        content: error?.message || '',
        level: 'info',
      };
    }

    // modify js_error level to info
    if (!(error.name && !error.name?.startsWith('['))) {
      return event;
    }

    if (error?.message?.includes('Loading chunk')) {
      error.name = `[warn][NetworkError] - Loading chunk Error`;
      error.message = 'Loading chunk failed, detail for extra.content';
    } else {
      error.name = `[info][NetworkError] - Network Error`;
      error.message = 'Network or fetch failed, detail for extra.content';
    }
    return event;
  }

  shouldHandle(event: WebReportEvent): event is JsErrorReport {
    return (
      event.ev_type === 'js_error' &&
      REG.test(event.payload.error?.message || '')
    );
  }
}
